import { render, staticRenderFns } from "./IzipayForm.vue?vue&type=template&id=10685954&scoped=true"
import script from "./IzipayForm.vue?vue&type=script&lang=js"
export * from "./IzipayForm.vue?vue&type=script&lang=js"
import style0 from "./IzipayForm.vue?vue&type=style&index=0&id=10685954&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10685954",
  null
  
)

export default component.exports